const KEY = 'code'

export function getCode() {
  return localStorage.getItem(KEY)
}

export function setCode(data) {
  return localStorage.setItem(KEY, data)
}
